export enum ICON {
  ADD = 'add',
  ANNOTATION_VISIBILITY = 'annotation_visibility',
  ARROW_UP = 'arrow_up',
  ARROW_UP_DOWN = 'arrow_up_down',
  ARROW_DOWN = 'arrow_down',
  CALENDAR = 'calendar',
  CALENDAR_TOOLS = 'calendar_tools',
  CAMERA = 'camera',
  CAM = 'cam',
  CARET_LEFT = 'caret_left',
  CARET_RIGHT = 'caret_right',
  CARS = 'cars',
  CHECKMARK = 'checkmark',
  CHECKMARK_FILLED = 'checkmark_filled',
  CHEVRON_DOWN = 'chevron_down',
  CHEVRON_LEFT = 'chevron_left',
  CHEVRON_RIGHT = 'chevron_right',
  CHEVRON_UP = 'chevron_up',
  CIRCLE_SOLID = 'circle_solid',
  CLOSE = 'close',
  CLUSTERS = 'clusters',
  CO2 = 'co2',
  COGWHEEL = 'cogwheel',
  COG_VIEW = 'cog_view',
  CURRENT_LOCATION = 'current_location',
  DOCUMENT_DOWNLOAD = 'document_download',
  EDIT = 'edit',
  ERROR = 'error',
  ERROR_FILLED = 'error_filled',
  GLOBE = 'globe',
  GLOBE_NETWORK = 'globe_network',
  GLOBE_NETWORK_FILLED = 'globe_network_filled',
  HAMBURGER = 'hamburger',
  HELP = 'help',
  INFORMATION_FILLED = 'information_filled',
  LAUNCH = 'launch',
  LOGO = 'logo',
  LOGO_TEXT = 'logo_text',
  LOGOUT = 'logout',
  MAP_MARKER = 'map_marker',
  MARKER_ARROW = 'marker_arrow',
  MARKER_CIRCLE = 'marker_circle',
  METER = 'meter',
  METER_FILLED = 'meter_filled',
  MOVE = 'move',
  PAUSE = 'pause',
  ROAD_WEATHER = 'road_weather',
  ROAD = 'road',
  ROUND_METER = 'round_meter',
  SEARCH = 'search',
  SEARCH_DATA = 'search_data',
  SENSOR_TEMPERATURE = 'sensor_temperature',
  STOP_SIGN = 'stop_sign',
  SUBTRACT = 'subtract',
  TOOL_KIT = 'tool_kit',
  TOOL_KIT_FILLED = 'tool_kit_filled',
  TRAFFIC_EVENT = 'traffic_event',
  TRASH = 'trash_can',
  USER_ADMIN = 'user_admin',
  USER_FILLED = 'user_filled',
  USERS_MULTIPLE = 'users_multiple',
  VEHICLE_INSIGHT = 'vehicle_insight',
  VEHICLE_INSIGHT_FILLED = 'vehicle_insight_filled',
  VEHICLE_SERVICE = 'vehicle_service',  
  VIDEO = 'video',
  VIDEO_MAP = 'video_map',
  VIEW = 'view',
  VIEW_FILLED = 'view_filled',
  VIEW_OFF = 'view_off',
  WARNING = 'warning',
  WARNING_ALT = 'warning_alt',
  WEATHER = 'weather',
  WEATHER_MAP = 'weather_map',
  ZOOM_AREA = 'zoom_area',
  ZOOM_AREA_FILLED = 'zoom_area_filled'
}
